import { Fade, Link as MuiLink, Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { formatName } from '../../../components/formatUtils';
import { useFindMitarbeiterByIdQuery } from '../api/mitarbeiterApi';

export function MitarbeiterLink({
  id,
  label,
  captionProps = {},
}: {
  id: string;
  label?: string;
  captionProps?: TypographyProps;
}) {
  const { data: mitarbeiter, isLoading } = useFindMitarbeiterByIdQuery(id);

  const linkElement = (
    <Fade in={!isLoading}>
      <MuiLink
        component={RouterLink}
        to={`/intern/mitarbeiter/${id}`}
        color="secondary"
        onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
      >
        {mitarbeiter && formatName(mitarbeiter, false)}
      </MuiLink>
    </Fade>
  );

  return label ? (
    <Typography
      variant="caption"
      {...captionProps}
      sx={[
        {
          color: 'text.secondary',
        },
        ...(Array.isArray(captionProps.sx) ? captionProps.sx : [captionProps.sx]),
      ]}
    >
      {label}
      <Typography
        variant="body1"
        sx={{
          color: 'text.primary',
        }}
      >
        {linkElement}
      </Typography>
    </Typography>
  ) : (
    linkElement
  );
}
